<template>
  <ClientOnly>
    <div class="language-switcher">
      <a
        v-for="locale in availableLocales"
        :key="locale.code"
        :href="switchLocalePath(locale.code)"
        class="language-switch t-menu-1"
        :class="{ 'language-switch--active': locale.code === currentLocale }"
      >
        {{ locale.localeCode }}
      </a>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
const { locale: currentLocale, locales } = useI18n()
const switchLocalePath = useSwitchLocalePath()

const availableLocales = computed(() =>
  locales.value
    .map(i => (typeof i === 'string' ? { code: i } : i))
    .map(localeObj => ({
      ...localeObj,
      localeCode: getLocaleCode(localeObj.code)
    }))
    .sort((a, b) => b.code.localeCompare(a.code))
)
</script>

<style lang="scss" scoped>
.language-switch {
  @include focus-visible;

  color: $layout-text-03;
  text-transform: uppercase;

  &:not(:last-child) {
    padding-right: rem(27px);
    margin-right: rem(28px);
    border-right: 1px solid $layout-divider;
  }

  &--active {
    color: $layout-text-01;
  }
}
</style>
